import React, { Component } from "react";
import { Link } from "react-router-dom";
import Content from "../../../content/Content";
import HeaderContent from "../../../content/Header";
import { Paths } from "../../../constants/UrlConstants";
import { logout } from "../../../actions/rootActions";
import { connect } from "react-redux";
import Store from "../../../content/Store";
import styles from "../../../assets/css/modules/header/header.css";
import { resetNotifications } from "../../../actions/notifications/notificationsAction";
import Logout from "../../logout/Logout";
import { Layouts } from "../../../constants/Constants";
import { CancelButton } from "./CancelButton";

const createHeader = (columnStyles, textStyles, headerText) => (
  <div className={columnStyles}>
    <div className={textStyles}>{headerText}</div>
  </div>
);

const createLogoutButton = (buttonStyles) => (
  <div className={buttonStyles}>
    <Logout doNotShowExitSurvey />
  </div>
);

export const mapStateToProps = ({
  accountReducer = {},
  policyReducer = {},
  layoutReducer = {}
}) => {
  const isInternalView =
    policyReducer.policyDetails && policyReducer.policyDetails.IsInternalView;
  return {
    isInternalView,
    isLoggedIn: accountReducer.isLoggedIn,
    isMolBrand: layoutReducer.layout === Layouts.MOL
  };
};

export class HeaderMin extends Component {
  onCancelClick = () => {
    if (
      this.props.headerTitle === Store.MakeAClaim.PageTitle ||
      (this.props.history &&
        this.props.history.location &&
        this.props.history.location.pathname === Paths.StartClaim)
    ) {
      this.props.history.push(Paths.Claims);
    } else {
      this.props.history.goBack();
    }
  };

  render() {
    let cancelButton = this.props.showCancelButton && (
      <CancelButton
        onClick={this.onCancelClick}
        buttonText={this.props.cancelButtonText}
      />
    );
    let headerMinContent = (
      <header id="ssoHeader" className={styles.header}>
        <div className={styles.mainNavbar}>
          <div
            className={`${styles.mainNavbarWrapper} ${styles.mainNavbarWrapperSSO} align-items-center`}
          >
            <div className={"col-4 col-md-3 " + styles.mainNavbarLogo}>
              <Content
                names={[
                  HeaderContent.Link.Src,
                  HeaderContent.Link.SrcSet,
                  HeaderContent.Link.SrcMin,
                  HeaderContent.Link.SrcMinSet,
                  HeaderContent.Link.AltText
                ]}
              >
                {(imgSrc, imgSrcset, srnMin, srnMinSet, altText) => (
                  <React.Fragment>
                    <Link id="brandHeader" to={Paths.HomeRoot}>
                      <img
                        src={imgSrc}
                        alt={altText}
                        className={
                          styles.mainNavbarLogoImage + " " + styles.axalogo
                        }
                        srcSet={imgSrcset}
                      />
                    </Link>

                    <Link
                      id="brandHeaderSmall"
                      className={styles.logoLink}
                      to={Paths.HomeRoot}
                    >
                      <img
                        src={srnMin}
                        alt={altText}
                        className={
                          styles.mainNavbarLogoImage + " " + styles.axalogosmall
                        }
                        srcSet={srnMinSet}
                      />
                    </Link>
                  </React.Fragment>
                )}
              </Content>
            </div>
            {createHeader(
              "col-5 col-sm-6 col-md-8",
              "min-header-title-sm text-sm-center text-uppercase",
              this.props.headerTitle
            )}
            {cancelButton}
            {this.props.showLogoutButton &&
              createLogoutButton(
                `${styles.logoutButton} col-sm-1 col-md-1 col-3`
              )}
          </div>
        </div>
      </header>
    );
    return (
      <React.Fragment>
        {this.props.isInternalView ? (
          <div id="top-banner" className={styles.internalTopBanner}>
            Internal View
          </div>
        ) : null}
        {headerMinContent}
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, { logout, resetNotifications })(
  HeaderMin
);
